/**
 * @description  Chat providers
 */

export default Object.freeze({
  DYDU: 'DYDU',
})
